import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import estateImg from '../../assets/tool-icon-estate-planning.png';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .bgW': {
        width: '285px',
        backgroundColor: '#fff',
    },
    '& .tableTool': {
        padding: '16px',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #D8D8D8',
        '& .searchWapper': {
            border: '1px solid #CCCCCC',
            borderRadius: '3px',
            width: '285px',
            height: '38px',
            '& .search': {
                height: '32px',
                color: '#58727C',
                padding: '0 10px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            border: '1px solid #CCCCCC',
        },
    },
    '& .MuiTab-root': {
        height: '30px !important',
    },
    '& .tab': {
        fontWeight: 'bold',
        backgroundColor: '#C1C0C2',
        color: '#fff',
        borderRadius: '6px 6px 0 0',
        marginRight: '4px',
    },
    '& .tabSelect': {
        fontWeight: 'bold',
        backgroundColor: '#7BC3E8',
        color: '#fff',
        borderRadius: '6px 6px 0 0',
        marginRight: '4px',
    },
    '& .tableWapper': {
        width: '100%',
        minHeight: '179px',
        backgroundColor: '#F9F7FA',
        padding: '10px',
    },
    '& .itemWapper': {
        width: '135px',
        height: '139px',
        backgroundColor: '#fff',
        cursor: 'pointer',
        margin: '10px',
        boxShadow: '1px 1px 7px 2px rgba(0,0,0,0.12)',
        borderRadius: '13px',
        transition: 'all 150ms cubic-bezier(0.02, 0.01, 0.47, 1)',
    },
    '& .text': {
        textAlign: 'center'
    },
    '& .itemWapper:hover': {
        color: '#005E96',
        fontWeight: 'bold',
        transform: 'translate(0,-5px)',
        transitionDelay: '0s !important',
    },
    '& .estateImg': {
        width: '60px',
        height: '62px',
        margin: '10px 0',
        background: `url(${estateImg}) no-repeat center top/cover`,
    },
});